import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sport-list',
  templateUrl: './sport-list.component.html',
  styleUrls: ['./sport-list.component.css']
})
export class SportListComponent implements OnInit {

  public api = api;
  public env = environment;
  public menu: any[] = [];
  private subs: Subscription[] = [];
  public data: any;
  public marketData: any;
  public oodsList: any[] = [];
  public oddsLisDis: any = {};
  public showLoader = true;
  public baseUrl: any = '';
  public marketsReq: any[] = [];
  public id: any = ''
  public sportName: any = ''
  public displayList: any = {};
  public newOddsEnable: boolean = false;
  public exposLisDis: any = {};
  public raceList: any;
  blockedEventIds: any[] = []

  constructor(public _shared: SharedService,
    public service: WebserviceService,
    public _common: CommonService,
    public _message: MessageService,
    public actRoute: ActivatedRoute,
    public router: Router,
    public _pusher: PusherService) {

    this.id = this.actRoute.snapshot.paramMap.get('sid');

    // if (this._common.getToken()) {
    const sub1 = this._pusher.eventListUpdate().subscribe(res => {

      if (res?.op == 'UPDATE') {
        // console.log("pusher");
        if (this.actRoute.snapshot.paramMap.get('sid') == '7' || this.actRoute.snapshot.paramMap.get('sid') == '4339') {
          // this.showLoader = true;
          this.getRaceListData(this.actRoute.snapshot.paramMap.get('sid'));
        } else {
          this.getListData();
        }
        // this.getListData();
      }
    });
    this.subs.push(sub1);
    // }

    //emit value in sequence every given second\
    const sub2 = interval(this.env.pollers.listOddsData).subscribe(val => {
      if (this.baseUrl != '') {
        // this.getOdds(this.marketsReq, this.data);
        if (this.newOddsEnable == true && this.marketData) {
          this.getOddsNew(this.marketsReq, this.data, this.marketData);
        } else {
          this.getOdds(this.marketsReq, this.data, true);
        }
      }
    });
    this.subs.push(sub2);
  }

  width: number = window.innerWidth;
  mobileWidth: number = 768;

  onWindowResize(event: any) {
    this.width = event.target.innerWidth;
    // console.log(`${this.width}`);
  }

  ngOnInit(): void {
    this.menu = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];
    if (this.actRoute.snapshot.paramMap.get('sid') == '7' || this.actRoute.snapshot.paramMap.get('sid') == '4339') {
      // this.showLoader = true;
      this.getRaceListData(this.actRoute.snapshot.paramMap.get('sid'));
    } else {
      this.getListData();
    }
  }


  getServices(): IbaseService<any> {
    return this.service;
  }

  getListData() {
    this.showLoader = true;
    // let el = this._common.getToken() ? this.api.eventList : this.api.eventListG;
    this.getServices().Get(`${this.env.baseUrl + this.api.eventList}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.blockedEventIds = res.data.blockedEventIds;
          this.baseUrl = (res.data.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
          res.data.events = this._common.UTC_to_Local_timeZone(res.data.events);

          // sidemenu content
          localStorage.removeItem(`${this.env.panel}sideMenu`);
          localStorage.setItem(`${this.env.panel}sideMenu`, JSON.stringify(res.data.events));
          this._shared.emitSideMenu(res.data.events);

          // this.featuredEvents(res.data.events);
          let market: any[] = [];
          res.data.events.forEach((element: any) => {
            market.push('market_ids[]=' + encodeURIComponent(element.market_id));
            element["exposure"] = 0;
            element["runner"] = element.name.split(" v ");
            if (res.data.exposes) {
              res.data.exposes.forEach((exp: any) => {
                if (exp.event_id == element.event_id) {
                  element["exposure"] = exp.expose;
                }
              });
            }
          });

          const uniqueSet = new Set(market);
          market = [...uniqueSet];
          this.data = res.data.events;
          this.showLoader = false;
          this.marketData = res.data

          this.marketsReq = market.join('&') as any;

          // this.getOdds(this.marketsReq, this.data);
          if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
            this.newOddsEnable = true;
            this.getOddsNew(this.marketsReq, this.data, res.data);
          } else {
            this.newOddsEnable = false;
            this.getOdds(this.marketsReq, this.data, res.data);
          }
          this.getExposure(market.join('&'), this.data);
        }
      },
      (err) => {
        console.log(err);
      });
  }
  getRaceListData(id: any) {
    this.showLoader = true;
    this.getServices().Get(`${this.env.baseUrl + this.api.raceList}/${id}`).subscribe(
      (res) => {
        if (res.status == true) {
          res.data.race = this._common.UTC_to_Local_timeZone(res.data.race);
          this.baseUrl = (res?.data?.connect_odds_hub == true) ? `https://${res.data.odds_hub}` : this.env.baseUrl;
          // remove raceData from this.data
          if (this.data) {
            this.data = this.data.filter((item: any) => {
              return item.event_type_id != id
            });
          } else {this.data = [];}

          this.featuredEvents(res.data.race);
          let market: any[] = [];
          res.data.race.forEach((element: any) => {
            market.push('market_ids[]=' + encodeURIComponent(element.market_id));
            // element["exposure"] = 0;
            element["event_type_id"] = id;
            element["runner"] = [];
          });

          const uniqueSet = new Set(market);
          market = [...uniqueSet];

          this.raceList = res.data.race;
          this.showLoader = false;
          this.data = [...this.data, ...res.data.race]
          this.marketsReq = market.join('&') as any;

          localStorage.removeItem(`${this.env.panel}sideRaceMenu${id}`);
          localStorage.setItem(`${this.env.panel}sideRaceMenu${id}`, JSON.stringify(res.data.race));
          this._shared.emitSideMenu(res.data.race);
          this.showLoader = false;
          // this.getOdds(this.marketsReq, this.data);
          if (res?.data?.bm_new_enable == true && res?.data?.fancy_new_enable == true && res?.data?.odds_new_enable == true) {
            this.newOddsEnable = true;
            this.getOddsNew(this.marketsReq, this.data, res.data);
          } else {
            this.newOddsEnable = false;
            this.getOdds(this.marketsReq, this.data, res.data);
          }
          this.getExposure(market.join('&'), this.data);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  getOdds(req: any, items: any, resData: any) {
    // let baseUrl = (resData?.connect_odds_hub == true) ? `https://${resData?.odds_hub}` : this.env.baseUrl;
    this.getServices().PostWithUrlEncoded(`${this.baseUrl + this.api.odds}`, req).subscribe(
      (res) => {

        // console.log(res);
        res = this._common.string_to_JSON(res);
        this.oodsList = this._common.compareData(res, this.oodsList);
        // console.log(this.oodsList);

        this.oddsLisDis = Object.assign({}, ...this.oodsList.map((elt: any) => ({ [elt.marketId]: elt })));
        // console.log(this.oddsLisDis);

        // items.forEach((ele: any) => {
        //   // ele["odds"] = {};
        //   res.forEach((element: any) => {
        //     if (element.marketId == ele.market_id || element.market_id == ele.market_id) {
        //       ele["odds"] = element;
        //     }
        //   });
        // });

        this.data = items;

        this.arrangeData();
        // }
        this.showLoader = false;
        // this.getExposure(req, this.data);
      },
      (err) => {
        console.log(err);
      });
  }

  oddsLisDisNew: any = {};
  getOddsNew(req: any, items: any, resData: any) {
    // let baseUrl = (resData?.connect_odds_hub == true) ? `https://${resData?.odds_hub}` : this.env.baseUrl;

    this.getServices().PostWithUrlEncoded(`${this.baseUrl + this.api.oddsNew}`, req).subscribe(
      (res) => {
        // if (res.status == true) {
        res = this._common.pipe_string_to_JSON(res);
        // console.log(res);

        // console.log(this.oddsLisDisNew);

        let resOdds: any = this._common.arrangeGetMarketNewData(res, resData);
        // console.log(resOdds);
        // console.log("=====================");
        if (this.oddsLisDisNew.length == 0) {
          this.oddsLisDisNew = resOdds;
        } else {
          let newOddsLD = resOdds;
          Object.keys(newOddsLD).forEach(key => {
            if (Object.keys(this.oddsLisDisNew).includes(key)) {
              delete this.oddsLisDisNew[key];
            }
          });
          this.oddsLisDisNew = { ...this.oddsLisDisNew, ...newOddsLD }
        }
        this.oddsLisDis = this.oddsLisDisNew;
        this.data = items;

        this.arrangeData();
        // }
        this.showLoader = false;
        // this.getExposure(req, this.data);
      },
      (err) => {
        console.log(err);
      });
  }

  getExposure(req: any, items: any) {
    let user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
    this.getServices().PostWithUrlEncoded(`${this.env.baseUrl + this.api.exposure}/${user?.id}`, req).subscribe(
      (res) => {
        if (res.status == true) {
          res = res.data.exposes;
          res = this._common.string_to_JSON(res);

          res.forEach((element: any) => {
            element["expo"] = element.reduce((a: any, b: any) => { return (b.expose < a.expose) ? b : a; });
            // let temp = Object.assign({}, ...element.map((elt: any) => ({ [elt.selection_id]: elt })));
            this.exposLisDis[element[0]?.marketId ? element[0]?.marketId : element[0]?.market_id] = element;
          });

          // console.log(this.exposLisDis);

          items.forEach((dt: any) => {
            res.forEach((element: any) => {
              element.forEach((expo: any, i: any) => {
                if (expo.event_id == dt.event_id) {
                  element["exposure"] = expo.expose;
                }
              });
            });
          });

          // items = this.setExposeData(items, res);
          // this.data = items;
          console.log(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  arrangeData() {

    // this.menu = this._common.generateSidebarMenuList(this.menu, this.data);

    const grouped = this._common.groupBy(this.data, (dat: any) => dat.event_type_id);

    this.menu.forEach((sm: any) => {
      let dt: any;
      let cdata = grouped.get(sm.id) ? grouped.get(sm.id) : [];
      // dt = { name: 'All', data: cdata, maninName: sm.name }
      sm["data"] = cdata;
    });

    this.menu.forEach(element => {
      if (element.id == this.actRoute.snapshot.paramMap.get('sid')) {
        this.displayList = element;
        // this.displayList.child = [];
        // element.child.forEach((ch: any) => {
        //   if (ch.name == 'All') {
        //     this.displayList.child = [ch]
        //   }
        // });
        this.sportName = (this.sportName == '') ? element.name : this.sportName;
      }
    });

    console.log(this.displayList);
  }

  multiMarketIds: any[] = [];
  multiMarketUpdate(item: any, key: any) {
    console.log(item);
    let url = (key == 'save') ? `${this.api.saveMultiMarket}/${item?.market_id}/${item?.event_id}/MATCH_ODDS/${this.data?.event?.event?.event_type_id}` : `${this.api.removeMultiMarket}/${item?.market_id}`;

    this.getServices().Get(`${this.env.baseUrl + this.api.multiMarket + url}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (key == 'save') {
            this.multiMarketIds.push(item?.market_id)
          } else {
            // this.multiMarketIds = JSON.parse(res?.data?.multi)
            if (this.actRoute.snapshot.paramMap.get('sid') == '7' || this.actRoute.snapshot.paramMap.get('sid') == '4339') {
              // this.showLoader = true;
              this.getRaceListData(this.actRoute.snapshot.paramMap.get('sid'));
            } else {
              this.getListData();
            }
          }
          // this.fancyRun = JSON.parse(res.data.position);
        }
      },
      (err) => {
        console.log(err)
      });
  }

  onSelect(data: any): void {
    this.sportName = data.name != 'All' ? data.name : this.displayList.name
    // data["isMobile"] = (this.width < this.mobileWidth) ? true : false;
    // if (data.id == 7 || data.id == 4339) {
    //   this.showLoader = true;
    //   this.getRaceListData(data.id);
    // } else if (data.id == '99999') {
    //   this._shared.emitTabCasino(data);
    // } else if (data.id == '99995') {
    //   this._shared.emitTabCasinoI(data);
    // }
    // }
    // this.showLoader = true;
    // data.tabData = [];
    // setTimeout(() => {
    //   this.arrangeData();
    //   this.showLoader = false;
    // }, 300)
    // }
    // console.log(data);

  }
  // onSelect(e: any) {
  //   e["isMobile"] = (this.width < this.mobileWidth) ? true : false;
  //   if (e != '') {
  //     if (data.id == '99999') {
  //       this._shared.emitTabCasino(e);
  //     } else if (data.id == '99995') {
  //       this._shared.emitTabCasinoI(e);
  //     }
  //   }
  // }

  featuredEvents(data: any) {
    const grouped = this._common.groupBy(data, (dat: any) => dat.featured_event);
    let fetEvents = grouped.get(1) ? grouped.get(1) : [];
    localStorage.removeItem(`${this.env.panel}upcoming`);
    localStorage.setItem(`${this.env.panel}upcoming`, JSON.stringify(fetEvents))
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  ngDoCheck() {
    if (this.id != this.actRoute.snapshot.paramMap.get('sid')) {
      if (this.actRoute.snapshot.paramMap.get('sid') == '7' || this.actRoute.snapshot.paramMap.get('sid') == '4339') {
        this.showLoader = true;
        this.getRaceListData(this.actRoute.snapshot.paramMap.get('sid'));
      } else {
        this.getListData();
      }
      this.sportName = '';
      this.displayList = {}
    }
    this.id = this.actRoute.snapshot.paramMap.get('sid');
  }

  // ngOnChanges() {
  //   this.smenu = this.data;
  // }

  detailPage(e: any) {
    // this.router.navigate(['/event/detail', e.event_id]);
  }

  confirmBox(key: any, item: any) {
    let msg = (key == 'lock') ? 'This Event Will Be Locked For Down-Line!' : 'This Event Will Be Unlocked For Down-Line!';
    Swal.fire({
      title: 'ARE YOU SURE?',
      text: msg,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancle'
    }).then((result) => {
      if (result.value) {
        this.lockUnlockEvent(key, item);
      }
    })
  }

  lockUnlockEvent(key: any, item: any) {
    let k = (key == 'lock') ? this.api.blockEvent : this.api.unBlockEvent;

    // console.log(k); return

    this.getServices().Get(`${this.env.baseUrl + this.api.eventList}/${item.event_id}${(key == 'lock') ? this.api.blockEvent : this.api.unBlockEvent}`).subscribe(
      (res) => {
        if (res.status == true) {
          if (key == 'lock') {
            this.blockedEventIds.push(item.event_id);
          } else {
            this.blockedEventIds.slice(this.blockedEventIds.indexOf(item.event_id), 1);
          }
          this._message.succmessage(`Event Succesfully ${key == 'lock' ? 'Lock' : 'Unlock'}`)
          // window.location.reload();
          this.getListData();
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }
}
